import { P2GBox } from '@parcel2go/core-ui';
import { ILinkProps, P2GLink } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { Suspense, useCallback, useContext, useMemo, useState } from 'react';
import { SmartSendContext } from '../../lib/context/SmartSendContext';
import { ToggleSelectionAllItemsAction } from '../../lib/context/SmartSendContextModels';
import QuickSelect from './quickselect/QuickSelect';
import { P2GSidePanel } from '~/components/sidepanel';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  selected: number;
  total: number;
  filterKey: string;
}

export default function SmartSendListyHeaderRowXs(props: props) {
  const ctx = useContext(SmartSendContext);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const setToggleAll = useCallback(
    (val: boolean) => ctx.dispatch(new ToggleSelectionAllItemsAction(props.filterKey, val)),
    [ctx, props.filterKey]
  );

  const links = useMemo(() => {
    const output: ILinkProps[] = [
      <P2GLink variant="body2" key="selected" onClick={() => setOpen(true)}>
        {props.selected === 1
          ? t('ONE_ITEM_SELECTED', { defaultValue: '1 Item Selected' })
          : t('MULTIPLE_ITEMS_SELECTED', { defaultValue: '{{count}} Items Selected', count: props.selected })}
      </P2GLink>
    ];

    if (props.selected < props.total) {
      output.push(
        <P2GLink variant="body2" key="select-all" onClick={() => setToggleAll(true)}>
          {t('SELECT_ALL_TOGGLE_LINK', { defaultValue: 'Select All' })}
        </P2GLink>
      );
    }

    if (props.selected > 0) {
      output.push(
        <P2GLink variant="body2" key="clear" onClick={() => setToggleAll(false)}>
          {t('CLEAR_ALL_TOGGLE_LINK', { defaultValue: 'Clear All' })}
        </P2GLink>
      );
    }

    return output;
  }, [props.selected, props.total, setToggleAll, t]);

  return (
    <>
      <P2GBox textAlign="center" pt={1}>
        <P2GLinkGroup links={links} />
      </P2GBox>
      <P2GSidePanel open={open} onClose={() => setOpen(false)} anchor="bottom">
        <P2GText>
          <strong>{t('QUICK_SELECT_BUTTON', { defaultValue: 'Select' })}</strong>
        </P2GText>
        {open && (
          <Suspense>
            <QuickSelect filterKey={props.filterKey} restrictToSold={false} selected={props.selected} isXs={true} />
          </Suspense>
        )}
      </P2GSidePanel>
    </>
  );
}
